import React from 'react';
import { Link } from 'react-router-dom';
import './Policy.css';

const PrivacyPolicy = () => (
  <div className="policy-page privacy-policy-page">
    <div className="page-header">
      <div className="page-header-content">
        <div className="container">
          <h1>PRIVACY POLICY</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Privacy Policy</span>
          </div>
          <p className="policy-banner-note">Last modified on 08 Jul, 2024</p>
        </div>
      </div>
    </div>
    <section className="policy-content">
      <div className="container">
        <div className="policy-box">
          <h2>Privacy Policy</h2>

          <h3>1. Introduction</h3>
          <p>Thank you for choosing us.</p>
          <p>
            This document i.e. Privacy Policy ("Policy") contains the manner and details in which
            Bulusu Digital Innovations Private Limited (BDI) that owns and controls the brand known
            as "DIGIRASA" collects and processes the data that you the user ("user" "you" "your") of
            this platform ("Platform") provide to us. Bulusu Digital Innovations Private Limited is
            a company incorporated under the Companies Act 2013 in India and having its registered
            office at 9-22/B/20 Boduppal Ghatkesar Hyderabad- 500092 Telangana.
          </p>
          <p>
            Please read this Policy before using the DIGIRASA Platform or submitting any personal
            information to DIGIRASA. This Policy is a part of and incorporated within and is to be
            read along with the <Link to="/terms-and-conditions">Terms and Conditions</Link>.
          </p>

          <h3>2. Policy Changes</h3>
          <p>
            We may change the terms of this Policy from time to time. We will notify you of any
            material changes to this policy as required by law. We will also post an updated copy on
            our website. Please check this page regularly for updates.
          </p>

          <h3>3. Information We Collect From You</h3>
          <div className="policy-table-wrap">
            <table className="policy-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Purpose</th>
                  <th>When Collected</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Name, Phone number, Email Address</td>
                  <td>For delivery of your food order</td>
                  <td>
                    When you order food/Subscribe to any of our packages or plans for availing our
                    services on DIGIRASA
                  </td>
                </tr>
                <tr>
                  <td>Age, Gender, Weight, Height, Physical and Mental Health, Medical History</td>
                  <td>To ensure the calories in the meals we provide are in the optimal range</td>
                  <td>When you subscribe to our nutrition plan</td>
                </tr>
                <tr>
                  <td>Payment Information</td>
                  <td>
                    We do not collect or store your payment information. In the event you choose to
                    "save card details for future transactions" our payment gateway may collect and
                    store your payment information.
                  </td>
                  <td>At the "checkout" stage from where you proceed to pay for your order.</td>
                </tr>
                <tr>
                  <td>Location Information</td>
                  <td>To enable swift and accurate delivery of your orders</td>
                  <td>
                    When you enter your delivery address or enable location services before placing
                    an order.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            The above list of data being collected is a non-exhaustive list and we may require you
            to share further information from time to time for which we will notify you.
          </p>

          <h3>4. Other Information</h3>
          <p>
            We may collect information about your IP address and the browser you're using. We might
            look at what site you came from, duration of time spent on our website, pages accessed,
            or what site you visit when you leave us. We might also collect the type of mobile
            device you are using or the version of the operating system your computer or device is
            running.
          </p>

          <h3>5. Why We Collect And Process Personal Data And How We Use It</h3>
          <ul>
            <li>To fulfil buying and selling requests on the Platform.</li>
            <li>
              To enable our nutritionists to communicate with you and send a personalised diet plan.
            </li>
            <li>To conduct business planning and forecasting.</li>
            <li>
              To enable us to diagnose and identify any technical advancements or troubleshoot
              issues.
            </li>
            <li>For marketing and advertising purposes.</li>
            <li>To answer your questions or requests for information or handle your complaints.</li>
            <li>
              To ensure that content provided regarding our Services is presented in the most
              effective manner for you and for your computer or other devices.
            </li>
            <li>
              To notify you about updates or changes to our Services or Platform features and
              content.
            </li>
            <li>
              To provide you with promotional communications to the extent that you have provided
              consent to receive such communications under applicable law.
            </li>
            <li>To comply with legal obligations and requests by law enforcement.</li>
            <li>To establish, exercise, or defend legal claims.</li>
            <li>
              Inferences drawn from your browsing patterns help us understand your preferences
              better, thereby allowing us to offer a more focused range of products and optimise our
              Services.
            </li>
            <li>
              Inferences drawn from how you interact with the Platform allow us to constantly
              identify what we could do better to help our users.
            </li>
            <li>
              To detect, investigate, and prevent fraudulent transactions and other illegal
              activities and protect the rights and property of Bulusu Digital Innovations Pvt Ltd.
            </li>
          </ul>

          <h3>6. Cookies</h3>
          <p>
            Some of the information collected will not personally identify you but will instead
            track your use of the Website so that we can better understand how the Website is used
            by customers and in turn enhance and improve your experience in ordering food.
          </p>
          <p>We collect Device Information using the following technologies:</p>
          <ul>
            <li>
              "Cookies" are a small data file transferred to your device that recognizes and
              identifies your device and allows your device to 'remember' information from the
              Website for future use.
            </li>
            <li>
              "Log Files" track actions occurring on the site and collect data including your IP
              address, browser type, Internet Service Provider, referring/exit page, data/time
              stamps.
            </li>
            <li>
              "Web beacons," "tags," and "pixels" are electronic files used to record information
              about how you browse the site.
            </li>
          </ul>
          <p>For more information please see our cookie policy.</p>

          <h3>7. Data Security Precautions</h3>
          <p>
            We have in place appropriate technical and security measures to secure the information
            collected by us.
          </p>
          <p>
            We use vault and tokenization services from third-party service providers to protect the
            sensitive personal information provided by you. The third-party service providers with
            respect to our vault and tokenization services and our payment gateway and payment
            processing are compliant with the payment card industry standard (generally referred to
            as PCI compliant service providers). You are advised not to send your full credit/debit
            card details through unencrypted electronic platforms. Where we have given you (or where
            you have chosen) a username and password which enables you to access certain parts of
            the DIGIRASA Platform you are responsible for keeping these details confidential. We ask
            you not to share your password with anyone.
          </p>
          <p>
            Please be aware that the transmission of information via the internet is not completely
            secure. Although we will do our best to protect your personal data, we cannot guarantee
            the security of your data transmitted through the DIGIRASA Platform. Once we have
            received your information, we will use strict physical, electronic, and procedural
            safeguards to try to prevent unauthorized access.
          </p>

          <h3>8. Optout</h3>
          <p>
            In the event you seek to opt-out of this tracking please contact us at{' '}
            <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>. Please note
            that this does not opt you out of being served advertisements. You may also opt-out of
            receiving advertisements across devices by adjusting your ad preference in your relevant
            device account, Google account, or Apple account.
          </p>

          <h3>9. Who Do We Share Your Data With</h3>
          <p>From time to time we may share your personal data with third parties such as:</p>
          <ul>
            <li>I.T. &amp; e-mail service providers</li>
            <li>Fraud prevention vendors</li>
            <li>Payment processors</li>
            <li>Law enforcement authorities</li>
            <li>Delivery service providers</li>
            <li>Advertising partners</li>
            <li>Data analytics agencies</li>
            <li>Social media partners</li>
            <li>Entities seeking to acquire or invest in Bulusu Digital Innovations Pvt Ltd</li>
          </ul>

          <h3>10. How Do We Protect Your Data</h3>
          <p>
            We implement appropriate technical and organizational measures to help protect the
            security of your personal data, including pseudonymization, encryption, access, and
            retention policies to guard against unauthorized access and unnecessary retention of
            personal data in our systems. Your password protects your account, and therefore we
            recommend using a strong password that is unique to your account.
          </p>

          <h3>11. Retention And Deletion Of Data</h3>
          <ul>
            <li>
              <strong>Retention of data:</strong> We collect and store your data for only as long as
              it is necessary for you to operate the Platform. In addition to this, we may also
              retain your data for legitimate and essential business purposes, including but not
              limited to making data-driven business decisions, complying with legal obligations,
              and resolving any disputes that may arise from time to time.
            </li>
            <li>
              <strong>Deletion of data:</strong> Unless legally allowed or legally mandated to store
              such data, upon receiving a request from the User, we will delete all your personal
              data or anonymize it so that such data is no longer identifiable to you as an
              individual.
            </li>
          </ul>

          <h3>12. Third-Party Links</h3>
          <p>
            The Platform may contain links to external websites owned and operated by third parties.
            Please note that when you use third-party services, their own Terms and Conditions and
            privacy policies will govern your use of those services. Bulusu Digital Innovations Pvt
            Ltd does not collect, process, or store any personal data provided by you to such
            third-party links, including the payment gateway through the Platform. Please check
            these policies before you submit any personal data to these external websites.
          </p>

          <h3>13. Governing Law, Jurisdiction And Arbitration</h3>
          <p>
            As provided in our <Link to="/terms-and-conditions">Terms and Conditions</Link>.
          </p>

          <div className="policy-help-box">
            <h3>How can you contact us about this notice?</h3>
            <p>If you have any questions or concerns about the privacy policy please contact us.</p>
            <p>
              <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
            </p>
            <p>
              <a href="tel:+918143231857">+91 81432 31857</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default PrivacyPolicy;
